import { Component, HostBinding, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'parser-plugin-link',
  templateUrl: './parser-plugin-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ParserPluginLinkComponent implements OnInit {
  readonly parserLinkDescription = $localize`:@@parser-plugin-link.parserLinkDescription:Improve your booking experience with`;
  browser: 'chrome' | 'firefox' | '';
  link: string;
  isExternal: boolean;

  private readonly browserLinks = {
    chrome: 'https://chrome.google.com/webstore/detail/parser-extension/fdapdekbmojmpnpojofifccoebgibhej',
    firefox: '/assets/content-catcher-extension.xpi'
  };

  @HostBinding() get class() {
    const display = this.link ? '' : 'd-none';
    return `parser-plugin-link ${display}`;
  }

  ngOnInit() {
    this.detectBrowser();
    this.isExternal = this.browser === 'chrome';
  }

  private detectBrowser() {
    this.browser =
      (window.navigator.userAgent.indexOf('Chrome') > -1 && 'chrome') ||
      (window.navigator.userAgent.indexOf('Firefox') > -1 && 'firefox') ||
      (!!window['chrome'] && (!!window['chrome'].webstore || !!window['chrome'].runtime) && 'chrome') ||
      (!!window['InstallTrigger'] && 'firefox');
    this.link = this.browser ? this.browserLinks[this.browser] : this.browserLinks['chrome'];
  }
}
